/**
 * First Variant Default
 *
 * Shopify preselects the first *available* variant, so a product whose first
 * variant is sold out opens on a different one. This forces the main product
 * page pickers onto product.variants[0] on load, unless the URL explicitly
 * requests a variant (?variant=...), e.g. from ads or shared links.
 */
(function () {
  'use strict';

  const PICKER_SELECTOR = 'variant-radios, variant-selects, variant-sticky-radios';

  function getVariants(picker) {
    const json = picker.querySelector('script[type="application/json"]');
    if (!json) return [];

    try {
      const data = JSON.parse(json.textContent);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }

  function selectFirstVariant(picker) {
    const firstVariant = getVariants(picker)[0];
    if (!firstVariant || !Array.isArray(firstVariant.options)) return;

    const groups = Array.from(picker.querySelectorAll('.product-form__input'));
    let lastControl = null;
    let changed = false;

    groups.forEach((group, domIndex) => {
      const parsedIndex = Number.parseInt(group.dataset.optionIndex, 10);
      const optionIndex = Number.isFinite(parsedIndex) ? parsedIndex : domIndex;
      const value = firstVariant.options[optionIndex];
      if (value === undefined || value === null) return;

      const select = group.querySelector('select');
      if (select) {
        const option = Array.from(select.options).find((item) => item.value === value);
        if (!option) return;
        if (select.value !== value) changed = true;
        option.disabled = false;
        select.value = value;
        lastControl = select;
        return;
      }

      const input = Array.from(group.querySelectorAll('input[type="radio"]')).find((item) => item.value === value);
      if (!input) return;
      if (!input.checked) changed = true;
      input.disabled = false;
      input.checked = true;
      lastControl = input;
    });

    if (!changed || !lastControl) return;

    // keepSelection tells dependent-variant-options.js not to swap a sold-out selection.
    const event = new Event('change', { bubbles: true });
    event.keepSelection = true;
    lastControl.dispatchEvent(event);
  }

  function start() {
    if (new URLSearchParams(window.location.search).has('variant')) return;

    document.querySelectorAll('script[data-first-variant-section]').forEach((script) => {
      const section = document.getElementById(`shopify-section-${script.dataset.firstVariantSection}`);
      if (section) section.querySelectorAll(PICKER_SELECTOR).forEach(selectFirstVariant);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
